import script from "./coreAdvantage.vue?vue&type=script&lang=ts&setup=true"
export * from "./coreAdvantage.vue?vue&type=script&lang=ts&setup=true"

import "./coreAdvantage.vue?vue&type=style&index=0&id=dd7ae206&lang=less&scoped=true"

import exportComponent from "/builds/26732/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dd7ae206"]])

export default __exports__